<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container " >
                <template #default>   <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-center" >
                <template #default>«ارسال کلیه سفارش‌ها طی ۲ تا ۵ روز کاری پس از ثبت و تأیید نهایی انجام خواهد شد.»   </template>
                </m-Alert-1><m-factor-4 v-bind='{...{"sellerName":"\u0641\u0631\u0648\u0634\u06af\u0627\u0647 \u062a\u06a9\u0646\u0648 \u067e\u0648\u0631\u062d\u0633\u06cc\u0646","addressProp":"\u062e\u0648\u0632\u0633\u062a\u0627\u0646\u060c \u062f\u0632\u0641\u0648\u0644\u060c \u0628\u0644\u0648\u0627\u0631 \u0633\u06cc\u062f\u0627\u0644\u0634\u0647\u062f\u0627 \u0631\u0648\u0628\u0631\u0648\u06cc \u062d\u0633\u06cc\u0646\u06cc\u0647 \u0634\u0647\u06cc\u062f\u0622\u0628\u0627\u062f","meliProp":"","signature":"","secondImageFactor":"","showDeliveryOption":true,"showCartonSize":true},...{}}' :style='""' class="" ></m-factor-4></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mFactor4 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor4';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mAlert1,mFactor4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
